import { Component, effect, EventEmitter, inject, Input, model, OnInit, Output } from '@angular/core';
import { entre0Y100 } from '../../../validators/transformations';
import { UsuarioCouchBase } from '../../../model/usuario';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '../../../abstract-component';

@Component({
  selector: 'app-couch-base-detalle-usuario',
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './couch-base-detalle-usuario.component.html',
  styleUrl: './couch-base-detalle-usuario.component.css'
})
export class CouchBaseDetalleUsuarioComponent extends AbstractComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  // Primero lo hacemos con el deprectado @Input y @Output y luego lo hacemos con el nuevo @Signal
  // Para probar propiedad de componente que admite entrada desde fuera y si el componente lo cambia, emite un evento de salida
  @Input() usuario?: Partial<UsuarioCouchBase>;
  @Output() cambioEnUsuarios = new EventEmitter();
  usuarioSignal = model<UsuarioCouchBase>()

  // Ahora con signals
  inputPropertySignal = model(0)

  usuarioForm = this.formBuilder.group({
    id: 0,
    nombre: ['', Validators.required],
    apellidos: ['', Validators.required],
    direccion: ['', Validators.required],
    fxNacimiento: ['', Validators.required],
    fxAlta: ['', Validators.required],
    fxModificacion: ['', Validators.required],
  });
  constructor() {
    super();
    console.log(`CouchBaseDetalleUsuarioComponent.constructor()`);
    effect(() => {
      console.log(`CouchBaseDetalleUsuarioComponent.effect() usuarioSignal: ${this.usuarioSignal()?.nombre}`);
      if (this.usuarioSignal) {
        console.log("Setting usuarioForm values from usuarioSignal");
        this.usuarioForm.patchValue({
          id: this.usuarioSignal()?.usuario_id,
          nombre: this.usuarioSignal()?.nombre,
          apellidos: this.usuarioSignal()?.apellidos,
          direccion: this.usuarioSignal()?.direccion,
          fxAlta: this.usuarioSignal()?.fxAlta?.toString(),
          fxModificacion: this.usuarioSignal()?.fxModificacion?.toString(),
          fxNacimiento: this.usuarioSignal()?.fxNacimiento?.toString(),
        });
      }
  });
  }

  ngOnInit() {
    console.log(`CouchBaseDetalleUsuarioComponent.ngOnInit()`);
    this.usuarioForm.get("id")?.setValue(0)
  }

  
  onDelete() {
    console.log("Delete button clicked");
    const usuarioId = this.usuarioForm.get('id')?.value!;
    this.usuarioForm.get("id")?.setValue(0)
    this.dhrService.deleteUserCouchBase(usuarioId).subscribe({
      next: (response) => {
        console.log('User deleted successfully:', response);
        this.cambioEnUsuarios.emit(response);
      },
      error: (error) => {
        console.error('Error deleting user:', error);
      }
    });
  }
  onClean() {
    console.log("Clean button clicked");
    this.usuarioForm.patchValue({
        id: 0,
        nombre: "",
        apellidos: "",
        direccion: "",
        fxAlta: "",
        fxModificacion: "",
        fxNacimiento: "",
      });
  }
  onSubmit(){
    console.log("Form submitted");
    console.log(`First Name: ${this.usuarioForm.get('nombre')?.value}`);
    const usuario: Partial<UsuarioCouchBase> = {
      nombre: this.usuarioForm.get('nombre')!.value!,
      apellidos: this.usuarioForm.get('apellidos')?.value!,
      direccion: this.usuarioForm.get('direccion')?.value!,
      fxNacimiento: new Date(this.usuarioForm.get('fxNacimiento')?.value!),
      fxAlta: new Date(this.usuarioForm.get('fxAlta')?.value!),
      fxModificacion: new Date(this.usuarioForm.get('fxModificacion')?.value!),
      usuario_id: this.usuarioForm.get('id')?.value!,
    };
    console.log(`Usuario: ${JSON.stringify(usuario)}`);
    this.dhrService.insertOrUpdateUserCouchBase(usuario).subscribe({
      next: (response: UsuarioCouchBase) => {
        console.log('Response from DhrService:', response);
        this.cambioEnUsuarios.emit(response);
      },
      error: (error: any) => {
        console.error('Error from DhrService:', error);
      }
    });

    //this.usuarioSignal()?.nombre = this.usuarioForm.get('nombre')?.value;

  }

}
